function About(){
    return(
        <div>
            <h1>Come back soon .... </h1>
        </div>
    )
}

export default About;